module.exports = __webpack_public_path__ + "static/urbano-logo-7aba06dd62125710cbdbc487deab8f34.png";